import * as React from 'react'
import { Link } from 'react-router-dom'

const wrap: React.CSSProperties = {
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '64px 24px',
  textAlign: 'center',
  gap: 16,
  background: 'var(--bg-base)',
  color: 'var(--text-primary)',
}

export function NotFoundPage(): React.JSX.Element {
  return (
    <div style={wrap}>
      <h1 className="h1">Page not found</h1>
      <p className="muted">The page you tried to open isn't here.</p>
      <Link to="/" className="btn btn-primary btn-md" style={{ textDecoration: 'none' }}>
        Back to dashboard
      </Link>
    </div>
  )
}

export function ForbiddenPage(): React.JSX.Element {
  return (
    <div style={wrap}>
      <h1 className="h1">You don't have access to that</h1>
      <p className="muted">Talk to an admin if you think this is a mistake.</p>
      <Link to="/" className="btn btn-primary btn-md" style={{ textDecoration: 'none' }}>
        Back to dashboard
      </Link>
    </div>
  )
}
